import { Injectable } from '@angular/core';
import { v4 as uuid } from 'uuid';
import { KEYS } from '../utils/constants/storage.constants';
import { SessionService } from './session.service';

@Injectable({
  providedIn: 'root',
})
export class DeviceHandlerService {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor(private readonly session: SessionService) {}

  public getCurrentDeviceID(): string {
    let id = localStorage.getItem(KEYS.DEVICE_REF);

    // Avoids creating a new deviceID for existing Session ID
    const sessionNotDefined = this.session.getSessionID() === undefined;

    // If session doesn't exist, can create new device ID
    if (sessionNotDefined) {
      if (id === null || (id !== null && id.trim().length === 0)) {
        id = this.generateDuid();
        localStorage.setItem(KEYS.DEVICE_REF, id);
      }

      if (
        id.trim().toUpperCase() === 'NULL' ||
        id.trim().toUpperCase() === 'UNDEFINED'
      ) {
        id = this.generateDuid();
        localStorage.setItem(KEYS.DEVICE_REF, id);
      }
    } else {
      if (
        id === null ||
        (id !== null && id.trim().length === 0) ||
        id === undefined ||
        id.trim().toUpperCase() === 'NULL' ||
        id.trim().toUpperCase() === 'UNDEFINED'
      ) {
        // This case should not happen, as the session is defined, therefore there must be a deviceref already in localStorage
        id = this.generateDuid();
        localStorage.setItem(KEYS.DEVICE_REF, id);
        const newSessionId = this.generateDuid();
        sessionStorage.setItem('sessionId', newSessionId.replace(/-/g, ''));
      }
    }

    return id;
  }

  /**
   * Get the device uid if the device is a tizen device, otherwise generate a uuid
   *
   * @returns device uid
   */
  generateDuid(): string {
    const userAgent = navigator.userAgent.toLowerCase();
    const isSmartTV =
      userAgent.includes('tizen') || userAgent.includes('web0s');
    // Validar si el useragent contiene la palabra 'web0s' o 'tizen'
    if (isSmartTV && window.duid) {
      const duid = window.duid;
      return duid;
    }
    return uuid();
  }
}
